<script setup>
 import Loader from "@/Components/Loader.vue";

const props = defineProps({
    flash: {},
});
  
const notification = (flash) => {
    
    if (flash.success) {
    alert(flash.success, "success");
    flash.success = null;

  }

  if (flash.error) {
    alert(flash.error, "error");
    flash.error = null;

  }
  if (flash.custom) {
    custom(flash.custom, "success");
    flash.custom = null;
  }
};

</script>

<template>
    <div class="wrapper">
        <div id="content-page" class="content-page">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12 px-0">
                        {{ notification($page.props.flash) }}
                       
                        <main >
                            <Loader />
                            <slot />
                        </main>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
